import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import { useAppDispatch } from '../../../store/store';
import { addRoleToCodeGroup } from '../../../store/adminCPTCodesSlice.slice';

export const AddRoleModal = (props: any) => {
    const dispatch = useAppDispatch();
    const [role, setRole] = useState('');
    const handleSubmit = () => {
        dispatch(addRoleToCodeGroup(role));
        props.onClose();
    };
    return (
        <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="sm">
            <DialogTitle>Add Role</DialogTitle>
            <DialogContent>
                <FormControl fullWidth sx={{ mt: 1 }}>
                    <InputLabel id="demo-simple-select-label">Role</InputLabel>
                    <Select label="Role" value={role} onChange={(e) => setRole(e.target.value)} sx={{ minWidth: '200px' }}>
                        <MenuItem value="" disabled>
                            Select Role
                        </MenuItem>
                        {props.roles.map((role) => (
                            <MenuItem key={role.Id} value={role.Name}>
                                {role.Name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button sx={{ minWidth: '120px' }} variant="outlined" color="primary" onClick={props.onClose}>
                    Cancel
                </Button>
                <Button sx={{ minWidth: '120px' }} variant="contained" color="primary" onClick={handleSubmit}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};
